export default __webpack_public_path__ + "static/media/Laura2.b2814fcc.JPG";